import React from 'react';

const Bone = ({ className }: { className: string }) => <div className={`skeleton ${className}`} />;

const LIST_COLUMNS = 9;
const INDICATOR_CARDS = 7;
const OUTCOME_CHIPS = 10;
const DETAIL_ROWS = 6;
const DETAIL_COLUMNS = 6;

function TableBones({ rows, cols }: { rows: number; cols: number }) {
  return (
    <div className="table-container">
      <div className="px-4 py-3 border-b border-border flex gap-4">
        {Array.from({ length: cols }).map((_, c) => <Bone key={c} className="h-3 flex-1" />)}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="px-4 py-3 border-b border-border flex gap-4 items-center">
          <div className="flex-[2] space-y-1.5">
            <Bone className="h-4 w-3/4" />
            <Bone className="h-3 w-1/2" />
          </div>
          {Array.from({ length: cols - 1 }).map((_, c) => <Bone key={c} className="h-4 flex-1" />)}
        </div>
      ))}
    </div>
  );
}

/** Mirrors the sends table (nine columns, name over subject); the search bar above it never unmounts. */
export const EmailSendsSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => (
  <TableBones rows={rows} cols={LIST_COLUMNS} />
);

/** Mirrors a send's detail: title block, seven indicator cards, outcome chips and the email grid. */
export const EmailSendDetailSkeleton: React.FC = () => (
  <div>
    <div className="mb-4 space-y-1.5">
      <Bone className="h-5 w-72" />
      <Bone className="h-4 w-96" />
      <Bone className="h-3 w-56" />
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3 mb-6">
      {Array.from({ length: INDICATOR_CARDS }).map((_, i) => (
        <div key={i} className="bg-surface border border-border rounded-lg p-3 space-y-2">
          <Bone className="h-3 w-16" />
          <Bone className="h-7 w-14" />
          <Bone className="h-3 w-20" />
        </div>
      ))}
    </div>
    <div className="bg-surface border border-border rounded-lg p-3 mb-4 flex flex-wrap gap-2">
      {Array.from({ length: OUTCOME_CHIPS }).map((_, i) => <Bone key={i} className="h-6 w-24 rounded-full" />)}
    </div>
    <TableBones rows={DETAIL_ROWS} cols={DETAIL_COLUMNS} />
  </div>
);
